<template>
  <header
    v-if="variants.v1 === variant"
    :class="[
      'header',
      '-type-1',
      'js-header',
      {
        scrolled: isScrolled,
        'fixed-color': vars.fixedColorBool,
        'is-hidden': isPopupOpen,
      },
    ]"
    :style="headerStyle"
  >
    <div data-anim="fade delay-3" class="header__container tw-items-center">
      <div class="header__left">
        <button :class="menuButtonClass" :style="menuButtonStyle" @click="toggleMenu">
          <i></i>
          <span>MENU</span>
        </button>
        <nuxt-link
          :to="homeLink"
          class="header__logo n-link"
          :external="true"
          :class="{ 'tw-block lg:tw-hidden': vars.logoCenterBool }"
        >
          <img
            v-if="company.company_key !== 'copeandco'"
            :src="vars.logoVersionText === 'v3' ? logoV3 : logo"
            alt="logo icon"
            class="logo-image"
            :class="{ '!tw-max-h-[80px]': shouldApplyV3LogoSize }"
          />
          <img
            v-if="company.company_key === 'copeandco'"
            :src="logoV1"
            alt="logo icon"
            class="logo-image"
            :class="{ '!tw-max-h-[80px]': shouldApplyV3LogoSize }"
          />
        </nuxt-link>
      </div>
      <nuxt-link
        :to="homeLink"
        v-if="company.company_key !== 'copeandco'"
        class="header__logo n-link"
        :external="true"
        :class="{ 'tw-hidden lg:tw-block': vars.logoCenterBool }"
      >
        <img
          :src="vars.logoVersionText === 'v3' ? logoV3 : logo"
          alt="logo icon"
          class="logo-image !tw-max-h-[80px]"
          :class="{ '!tw-max-h-[80px]': shouldApplyV3LogoSize }"
        />
      </nuxt-link>
      <div class="header__right">
        <div v-if="vars.socials" class="header__socials">
          <a
            v-for="(item, i) in (vars.socials as unknown as SocialItem[]) || []"
            :key="`social-${i}`"
            :href="item.url"
            :class="item.iconClass"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <div v-if="vars.languages" class="header__language lg:d-none">
          <template v-for="(lang, idx) in (vars.languages as unknown as string[]) || []" :key="lang">
            <a href="javascript:void(0)" @click.prevent="changeLanguage(lang)">
              {{ lang.toUpperCase() }}
            </a>
            <span v-if="idx < ((vars.languages as unknown as string[]) || []).length - 1"></span>
          </template>
        </div>
        <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-start tw-gap-3">
          <div class="tw-flex tw-gap-3">
            <nuxt-link
              v-if="company.company_key !== 'keystonepmc'"
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? '' : 'tw-w-auto',
                menuVisible && company.company_key !== 'copeandco' ? 'n-primary' : `n-${button.button_type}`,
                'tw-uppercase',
                company.company_key === 'keystonepmc' && isScrolled ? 'n-primary' : '',
              ]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>

            <nuxt-link
              v-if="company.company_key === 'keystonepmc'"
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? '' : 'tw-w-auto',
                menuVisible || isScrolled ? 'n-primary' : `n-${button.button_type}`,
                'tw-uppercase',
              ]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div
    v-if="variants.v1 === variant"
    class="menu -top-header js-menu"
    :class="{ 'is-open': menuVisible }"
    :style="menuStyle"
  >
    <div class="menu__left !tw-bg-white">
      <div class="menuNav js-menuNav">
        <div
          v-for="(menuItem, itemIndex) in columnOneMenu"
          :key="`menuItem-${itemIndex}`"
          class="menuNav__item"
          :class="menuItem.has_sub_menu ? '-has-submenu js-has-submenu' : ''"
        >
          <a
            href="javascript:void(0)"
            class="tw-group hover:!tw-text-[var(--c-secondary)]"
            @click="menuItem.has_sub_menu ? toggleSubMenu(itemIndex) : handleMenuLinkClick(menuItem)"
            :aria-expanded="openSubMenu === itemIndex"
          >
            <h4>{{ menuItem.name }}</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <svg
              v-if="menuItem.has_sub_menu === true"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 8.49799H8V14.498H6V8.49799H0V6.49799H6V0.497986H8V6.49799H14V8.49799Z"
                fill="black"
                class="tw-duration-300 group-hover:tw-fill-[var(--c-secondary)]"
              />
            </svg>
          </a>
          <div
            class="submenu js-submenu"
            :class="{ 'is-active': openSubMenu === itemIndex }"
            role="region"
            :aria-hidden="openSubMenu !== itemIndex"
          >
            <div class="submenu__wrap">
              <div
                class="submenu__item"
                v-for="(subMenu, sIndex) in menuItem.sub_menus"
                :key="`subMenu-${itemIndex}-${sIndex}`"
              >
                <nuxt-link
                  :to="subMenu.url || '/'"
                  :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
                  :external="true"
                >
                  <h6>{{ subMenu.name }}</h6>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu__right tw-relative">
      <NuxtImg
        v-if="vars.backgroundImage"
        :src="(vars.backgroundImage as string) || ''"
        class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      />
    </div>

    <div
      class="menu__close js-menuClose js-menu-button"
      style="border-color: var(--c-primary) !important"
      @click="toggleMenu"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
          fill="#000"
        />
      </svg>
    </div>
  </div>

  <header
    v-if="variants.v2 === variant"
    :class="[
      'header',
      '-type-1',
      'js-header',
      {
        scrolled: isScrolled,
        'fixed-color': vars.fixedColorBool,
        'is-hidden': isPopupOpen,
      },
    ]"
    class="v2 tw-flex tw-flex-col tw-items-center tw-justify-center"
    style=""
    :style="headerStyle"
  >
    <div data-anim="fade delay-3" class="header__container tw-items-center">
      <div class="header__left tw-flex-row-reverse">
        <div class="tw-flex tw-items-center tw-gap-5">
          <nuxt-link :to="homeLink" class="header__logo n-link tw-w-[130px]" :external="true">
            <NuxtImg :src="logoV2" alt="logo icon" class="logo-image !tw-w-full" />
          </nuxt-link>
          <button
            @click="toggleTheme"
            class="focus:outline-none tw-group !tw-rounded-full tw-transition-transform tw-duration-300 hover:tw-scale-95"
            style="border-color: var(--c-text_primary); padding: 12px !important"
          >
            <svg
              v-if="!isLightMode"
              class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.375 3.125V1.25C9.375 1.08424 9.44085 0.925268 9.55806 0.808058C9.67527 0.690848 9.83424 0.625 10 0.625C10.1658 0.625 10.3247 0.690848 10.4419 0.808058C10.5592 0.925268 10.625 1.08424 10.625 1.25V3.125C10.625 3.29076 10.5592 3.44973 10.4419 3.56694C10.3247 3.68415 10.1658 3.75 10 3.75C9.83424 3.75 9.67527 3.68415 9.55806 3.56694C9.44085 3.44973 9.375 3.29076 9.375 3.125ZM15 10C15 10.9889 14.7068 11.9556 14.1573 12.7779C13.6079 13.6001 12.827 14.241 11.9134 14.6194C10.9998 14.9978 9.99445 15.0969 9.02455 14.9039C8.05464 14.711 7.16373 14.2348 6.46447 13.5355C5.7652 12.8363 5.289 11.9454 5.09607 10.9755C4.90315 10.0055 5.00216 9.00021 5.3806 8.08658C5.75904 7.17295 6.3999 6.39206 7.22215 5.84265C8.04439 5.29324 9.01109 5 10 5C11.3256 5.00145 12.5966 5.5287 13.5339 6.46606C14.4713 7.40343 14.9986 8.67436 15 10ZM13.75 10C13.75 9.25832 13.5301 8.5333 13.118 7.91661C12.706 7.29993 12.1203 6.81928 11.4351 6.53545C10.7498 6.25162 9.99584 6.17736 9.26841 6.32206C8.54098 6.46675 7.8728 6.8239 7.34835 7.34835C6.8239 7.8728 6.46675 8.54098 6.32206 9.26841C6.17736 9.99584 6.25162 10.7498 6.53545 11.4351C6.81928 12.1203 7.29993 12.706 7.91661 13.118C8.5333 13.5301 9.25832 13.75 10 13.75C10.9942 13.749 11.9475 13.3535 12.6505 12.6505C13.3535 11.9475 13.749 10.9942 13.75 10ZM4.55781 5.44219C4.67509 5.55946 4.83415 5.62535 5 5.62535C5.16585 5.62535 5.32491 5.55946 5.44219 5.44219C5.55946 5.32491 5.62535 5.16585 5.62535 5C5.62535 4.83415 5.55946 4.67509 5.44219 4.55781L4.19219 3.30781C4.07491 3.19054 3.91585 3.12465 3.75 3.12465C3.58415 3.12465 3.42509 3.19054 3.30781 3.30781C3.19054 3.42509 3.12465 3.58415 3.12465 3.75C3.12465 3.91585 3.19054 4.07491 3.30781 4.19219L4.55781 5.44219ZM4.55781 14.5578L3.30781 15.8078C3.19054 15.9251 3.12465 16.0841 3.12465 16.25C3.12465 16.4159 3.19054 16.5749 3.30781 16.6922C3.42509 16.8095 3.58415 16.8753 3.75 16.8753C3.91585 16.8753 4.07491 16.8095 4.19219 16.6922L5.44219 15.4422C5.50026 15.3841 5.54632 15.3152 5.57775 15.2393C5.60917 15.1634 5.62535 15.0821 5.62535 15C5.62535 14.9179 5.60917 14.8366 5.57775 14.7607C5.54632 14.6848 5.50026 14.6159 5.44219 14.5578C5.38412 14.4997 5.31518 14.4537 5.23931 14.4223C5.16344 14.3908 5.08212 14.3747 5 14.3747C4.91788 14.3747 4.83656 14.3908 4.76069 14.4223C4.68482 14.4537 4.61588 14.4997 4.55781 14.5578ZM15 5.625C15.0821 5.62506 15.1634 5.60895 15.2393 5.57759C15.3152 5.54622 15.3841 5.50021 15.4422 5.44219L16.6922 4.19219C16.8095 4.07491 16.8753 3.91585 16.8753 3.75C16.8753 3.58415 16.8095 3.42509 16.6922 3.30781C16.5749 3.19054 16.4159 3.12465 16.25 3.12465C16.0841 3.12465 15.9251 3.19054 15.8078 3.30781L14.5578 4.55781C14.4703 4.64522 14.4107 4.75663 14.3865 4.87793C14.3624 4.99924 14.3748 5.12498 14.4221 5.23924C14.4695 5.35351 14.5496 5.45116 14.6525 5.51982C14.7554 5.58849 14.8763 5.6251 15 5.625ZM15.4422 14.5578C15.3249 14.4405 15.1659 14.3747 15 14.3747C14.8341 14.3747 14.6751 14.4405 14.5578 14.5578C14.4405 14.6751 14.3747 14.8341 14.3747 15C14.3747 15.1659 14.4405 15.3249 14.5578 15.4422L15.8078 16.6922C15.8659 16.7503 15.9348 16.7963 16.0107 16.8277C16.0866 16.8592 16.1679 16.8753 16.25 16.8753C16.3321 16.8753 16.4134 16.8592 16.4893 16.8277C16.5652 16.7963 16.6341 16.7503 16.6922 16.6922C16.7503 16.6341 16.7963 16.5652 16.8277 16.4893C16.8592 16.4134 16.8753 16.3321 16.8753 16.25C16.8753 16.1679 16.8592 16.0866 16.8277 16.0107C16.7963 15.9348 16.7503 15.8659 16.6922 15.8078L15.4422 14.5578ZM3.75 10C3.75 9.83424 3.68415 9.67527 3.56694 9.55806C3.44973 9.44085 3.29076 9.375 3.125 9.375H1.25C1.08424 9.375 0.925268 9.44085 0.808058 9.55806C0.690848 9.67527 0.625 9.83424 0.625 10C0.625 10.1658 0.690848 10.3247 0.808058 10.4419C0.925268 10.5592 1.08424 10.625 1.25 10.625H3.125C3.29076 10.625 3.44973 10.5592 3.56694 10.4419C3.68415 10.3247 3.75 10.1658 3.75 10ZM10 16.25C9.83424 16.25 9.67527 16.3158 9.55806 16.4331C9.44085 16.5503 9.375 16.7092 9.375 16.875V18.75C9.375 18.9158 9.44085 19.0747 9.55806 19.1919C9.67527 19.3092 9.83424 19.375 10 19.375C10.1658 19.375 10.3247 19.3092 10.4419 19.1919C10.5592 19.0747 10.625 18.9158 10.625 18.75V16.875C10.625 16.7092 10.5592 16.5503 10.4419 16.4331C10.3247 16.3158 10.1658 16.25 10 16.25ZM18.75 9.375H16.875C16.7092 9.375 16.5503 9.44085 16.4331 9.55806C16.3158 9.67527 16.25 9.83424 16.25 10C16.25 10.1658 16.3158 10.3247 16.4331 10.4419C16.5503 10.5592 16.7092 10.625 16.875 10.625H18.75C18.9158 10.625 19.0747 10.5592 19.1919 10.4419C19.3092 10.3247 19.375 10.1658 19.375 10C19.375 9.83424 19.3092 9.67527 19.1919 9.55806C19.0747 9.44085 18.9158 9.375 18.75 9.375Z"
                fill="var(--c-text_primary)"
              />
            </svg>
            <svg v-else width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.1352 10.2218C16.075 10.1617 15.9995 10.1191 15.917 10.0986C15.8344 10.0781 15.7478 10.0805 15.6664 10.1054C14.4477 10.4738 13.1518 10.5046 11.9169 10.1945C10.682 9.88445 9.55439 9.24514 8.65421 8.34471C7.75402 7.44428 7.11501 6.31649 6.80527 5.08152C6.49552 3.84655 6.52666 2.55067 6.89535 1.332C6.91998 1.25073 6.92207 1.1643 6.9014 1.08194C6.88073 0.999575 6.83807 0.924373 6.77799 0.864367C6.7179 0.804361 6.64264 0.761805 6.56025 0.741243C6.47786 0.720682 6.39143 0.722888 6.3102 0.747627C4.69423 1.2434 3.27569 2.23602 2.25629 3.58435C1.10071 5.11879 0.538301 7.01901 0.67258 8.93522C0.80686 10.8514 1.62879 12.6546 2.98708 14.0129C4.34537 15.3712 6.14858 16.1931 8.06479 16.3274C9.98099 16.4617 11.8812 15.8993 13.4157 14.7437C14.764 13.7243 15.7566 12.3058 16.2524 10.6898C16.2771 10.6085 16.2793 10.522 16.2586 10.4396C16.238 10.3572 16.1953 10.2819 16.1352 10.2218ZM12.8539 13.9945C11.4999 15.01 9.82503 15.503 8.13676 15.3831C6.44849 15.2631 4.86015 14.5381 3.66335 13.3413C2.46655 12.1445 1.74162 10.5562 1.62163 8.86794C1.50165 7.17967 1.99468 5.50477 3.0102 4.15075C3.73352 3.19171 4.68829 2.43181 5.7852 1.94216C5.55426 3.21061 5.63437 4.51615 6.01866 5.74685C6.40294 6.97756 7.07994 8.09672 7.99162 9.00839C8.90329 9.92007 10.0225 10.5971 11.2532 10.9814C12.4839 11.3656 13.7894 11.4457 15.0579 11.2148C14.5695 12.3132 13.8104 13.2696 12.8516 13.9945H12.8539Z"
                fill="var(--c-text_primary)"
              />
            </svg>
          </button>
        </div>
        <button
          class="n-link md:!tw-hidden"
          style="color: var(--c-text_primary) !important"
          :class="menuButtonClass"
          :style="menuButtonStyle"
          @click="toggleMenu"
        >
          <i class="custom-color-menu"></i>
        </button>
      </div>
      <div class="header__right">
        <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-start tw-gap-3">
          <div class="tw-hidden tw-items-center tw-justify-center tw-gap-1 lg:tw-flex">
            <nuxt-link v-if="vars.facebookUrl" :external="true" :to="vars.facebookUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M19.6693 19.2501H21.7526L22.5859 15.9167H19.6693V14.2501C19.6693 13.3917 19.6693 12.5834 21.3359 12.5834H22.5859V9.78341C22.3143 9.74758 21.2884 9.66675 20.2051 9.66675C17.9426 9.66675 16.3359 11.0476 16.3359 13.5834V15.9167H13.8359V19.2501H16.3359V26.3334H19.6693V19.2501Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.tiktokUrl" :external="true" :to="vars.tiktokUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M21.8354 12.85C21.2658 12.1997 20.9518 11.3645 20.9521 10.5H18.3771V20.8333C18.3572 21.3925 18.1211 21.9222 17.7186 22.3108C17.316 22.6994 16.7783 22.9166 16.2188 22.9167C15.0354 22.9167 14.0521 21.95 14.0521 20.75C14.0521 19.3167 15.4354 18.2417 16.8604 18.6833V16.05C13.9854 15.6667 11.4688 17.9 11.4688 20.75C11.4688 23.525 13.7688 25.5 16.2104 25.5C18.8271 25.5 20.9521 23.375 20.9521 20.75V15.5083C21.9962 16.2582 23.2499 16.6605 24.5354 16.6583V14.0833C24.5354 14.0833 22.9688 14.1583 21.8354 12.85Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.instagramUrl" :external="true" :to="vars.instagramUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M14.4974 9.66675H21.4974C24.1641 9.66675 26.3307 11.8334 26.3307 14.5001V21.5001C26.3307 22.782 25.8215 24.0113 24.9151 24.9178C24.0087 25.8242 22.7793 26.3334 21.4974 26.3334H14.4974C11.8307 26.3334 9.66406 24.1667 9.66406 21.5001V14.5001C9.66406 13.2182 10.1733 11.9888 11.0797 11.0824C11.9861 10.176 13.2155 9.66675 14.4974 9.66675ZM14.3307 11.3334C13.5351 11.3334 12.772 11.6495 12.2094 12.2121C11.6468 12.7747 11.3307 13.5378 11.3307 14.3334V21.6667C11.3307 23.3251 12.6724 24.6667 14.3307 24.6667H21.6641C22.4597 24.6667 23.2228 24.3507 23.7854 23.7881C24.348 23.2255 24.6641 22.4624 24.6641 21.6667V14.3334C24.6641 12.6751 23.3224 11.3334 21.6641 11.3334H14.3307ZM22.3724 12.5834C22.6487 12.5834 22.9136 12.6932 23.109 12.8885C23.3043 13.0839 23.4141 13.3488 23.4141 13.6251C23.4141 13.9013 23.3043 14.1663 23.109 14.3617C22.9136 14.557 22.6487 14.6667 22.3724 14.6667C22.0961 14.6667 21.8312 14.557 21.6358 14.3617C21.4405 14.1663 21.3307 13.9013 21.3307 13.6251C21.3307 13.3488 21.4405 13.0839 21.6358 12.8885C21.8312 12.6932 22.0961 12.5834 22.3724 12.5834ZM17.9974 13.8334C19.1025 13.8334 20.1623 14.2724 20.9437 15.0538C21.7251 15.8352 22.1641 16.895 22.1641 18.0001C22.1641 19.1052 21.7251 20.165 20.9437 20.9464C20.1623 21.7278 19.1025 22.1667 17.9974 22.1667C16.8923 22.1667 15.8325 21.7278 15.0511 20.9464C14.2697 20.165 13.8307 19.1052 13.8307 18.0001C13.8307 16.895 14.2697 15.8352 15.0511 15.0538C15.8325 14.2724 16.8923 13.8334 17.9974 13.8334ZM17.9974 15.5001C17.3344 15.5001 16.6985 15.7635 16.2296 16.2323C15.7608 16.7012 15.4974 17.337 15.4974 18.0001C15.4974 18.6631 15.7608 19.299 16.2296 19.7678C16.6985 20.2367 17.3344 20.5001 17.9974 20.5001C18.6604 20.5001 19.2963 20.2367 19.7652 19.7678C20.234 19.299 20.4974 18.6631 20.4974 18.0001C20.4974 17.337 20.234 16.7012 19.7652 16.2323C19.2963 15.7635 18.6604 15.5001 17.9974 15.5001Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.youtubeUrl" :external="true" :to="vars.youtubeUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <g clip-path="url(#clip0_32_232)">
                    <path
                      d="M17.9974 11.3333C18.7099 11.3333 19.4407 11.3516 20.1491 11.3816L20.9857 11.4216L21.7866 11.4691L22.5366 11.5199L23.2216 11.5733C23.9649 11.6302 24.6644 11.9474 25.197 12.4691C25.7296 12.9909 26.0611 13.6837 26.1332 14.4258L26.1666 14.7799L26.2291 15.5383C26.2874 16.3241 26.3307 17.1808 26.3307 17.9999C26.3307 18.8191 26.2874 19.6758 26.2291 20.4616L26.1666 21.2199C26.1557 21.3416 26.1449 21.4591 26.1332 21.5741C26.0611 22.3163 25.7294 23.0092 25.1967 23.531C24.6639 24.0527 23.9643 24.3699 23.2207 24.4266L22.5374 24.4791L21.7874 24.5308L20.9857 24.5782L20.1491 24.6182C19.4323 24.6494 18.7149 24.6655 17.9974 24.6666C17.2799 24.6655 16.5625 24.6494 15.8457 24.6182L15.0091 24.5782L14.2082 24.5308L13.4582 24.4791L12.7732 24.4266C12.0299 24.3697 11.3304 24.0525 10.7978 23.5307C10.2652 23.009 9.93371 22.3161 9.86156 21.5741L9.82823 21.2199L9.76573 20.4616C9.70201 19.6425 9.6681 18.8214 9.66406 17.9999C9.66406 17.1808 9.7074 16.3241 9.76573 15.5383L9.82823 14.7799C9.83906 14.6583 9.8499 14.5408 9.86156 14.4258C9.93368 13.6838 10.2651 12.9911 10.7975 12.4694C11.3299 11.9476 12.0292 11.6303 12.7724 11.5733L13.4566 11.5199L14.2066 11.4691L15.0082 11.4216L15.8449 11.3816C16.562 11.3504 17.2796 11.3343 17.9974 11.3333ZM17.9974 12.9999C17.3099 12.9999 16.6024 13.0183 15.9141 13.0466L15.0991 13.0858L14.3166 13.1316L13.5816 13.1816L12.9082 13.2341C12.5543 13.2592 12.2208 13.4088 11.9666 13.6564C11.7125 13.9039 11.5542 14.2335 11.5199 14.5866C11.4224 15.5941 11.3307 16.8483 11.3307 17.9999C11.3307 19.1516 11.4224 20.4058 11.5199 21.4133C11.5907 22.1399 12.1674 22.7049 12.9082 22.7658L13.5816 22.8174L14.3166 22.8674L15.0991 22.9141L15.9141 22.9533C16.6024 22.9816 17.3099 22.9999 17.9974 22.9999C18.6849 22.9999 19.3924 22.9816 20.0807 22.9533L20.8957 22.9141L21.6782 22.8682L22.4132 22.8183L23.0866 22.7658C23.4405 22.7406 23.774 22.591 24.0282 22.3435C24.2823 22.0959 24.4405 21.7664 24.4749 21.4133C24.5724 20.4058 24.6641 19.1516 24.6641 17.9999C24.6641 16.8483 24.5724 15.5941 24.4749 14.5866C24.4405 14.2335 24.2823 13.9039 24.0282 13.6564C23.774 13.4088 23.4405 13.2592 23.0866 13.2341L22.4132 13.1824L21.6782 13.1324L20.8957 13.0858L20.0807 13.0466C19.3867 13.0167 18.6921 13.0012 17.9974 12.9999ZM16.3307 15.9791C16.3307 15.8976 16.3505 15.8174 16.3885 15.7454C16.4265 15.6733 16.4816 15.6117 16.5489 15.5658C16.6161 15.5199 16.6936 15.4911 16.7745 15.4819C16.8555 15.4728 16.9374 15.4835 17.0132 15.5133L17.0807 15.5466L20.5807 17.5666C20.6504 17.6068 20.7094 17.6632 20.7526 17.7311C20.7958 17.799 20.822 17.8763 20.829 17.9565C20.8359 18.0366 20.8234 18.1173 20.7925 18.1916C20.7617 18.2659 20.7133 18.3316 20.6516 18.3833L20.5807 18.4333L17.0807 20.4541C17.0102 20.4949 16.9308 20.5179 16.8493 20.521C16.7679 20.5241 16.6869 20.5073 16.6134 20.472C16.54 20.4367 16.4763 20.3839 16.4279 20.3183C16.3795 20.2528 16.3478 20.1763 16.3357 20.0958L16.3307 20.0208V15.9791Z"
                      fill="var(--c-text_primary)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_32_232">
                      <rect width="20" height="20" fill="var(--c-text_primary)" transform="translate(8 8)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.linkedinUrl" :external="true" :to="vars.linkedinUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M13.7865 12.1668C13.7862 12.6088 13.6104 13.0326 13.2977 13.345C12.985 13.6574 12.561 13.8328 12.119 13.8326C11.6769 13.8324 11.2531 13.6566 10.9407 13.3439C10.6283 13.0311 10.4529 12.6071 10.4531 12.1651C10.4533 11.7231 10.6292 11.2992 10.9419 10.9868C11.2546 10.6744 11.6786 10.499 12.1206 10.4993C12.5627 10.4995 12.9865 10.6753 13.2989 10.988C13.6113 11.3007 13.7867 11.7247 13.7865 12.1668ZM13.8365 15.0668H10.5031V25.5001H13.8365V15.0668ZM19.1031 15.0668H15.7865V25.5001H19.0698V20.0251C19.0698 16.9751 23.0448 16.6918 23.0448 20.0251V25.5001H26.3365V18.8918C26.3365 13.7501 20.4531 13.9418 19.0698 16.4668L19.1031 15.0668Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
          <div class="tw-flex tw-gap-3">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? '' : 'tw-w-auto',
                menuVisible ? 'n-primary' : `n-${button.button_type}`,
                'tw-uppercase',
              ]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>

          <button :class="menuButtonClass" :style="menuButtonStyle" @click="toggleMenu">
            <i class="custom-color-menu"></i>
          </button>
        </div>
      </div>
    </div>
  </header>

  <div
    v-if="variants.v2 === variant"
    class="menu -top-header js-menu"
    :class="{ 'is-open': menuVisible }"
    :style="menuStyle"
  >
    <div class="menu__right tw-relative">
      <NuxtImg
        v-if="vars.backgroundImage"
        :src="(vars.backgroundImage as string) || ''"
        class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      />
    </div>
    <div class="menu__left" style="background-color: var(--c-section_primary)">
      <div class="menuNav js-menuNav tw-flex tw-flex-col md:!tw-ml-20">
        <div
          v-for="(menuItem, itemIndex) in columnOneMenu"
          :key="`menuItem-${itemIndex}`"
          class="menuNav__item"
          :class="menuItem.has_sub_menu ? '-has-submenu js-has-submenu' : ''"
        >
          <a
            href="javascript:void(0)"
            class="tw-group !tw-normal-case hover:!tw-text-[var(--c-primary)]"
            @click="menuItem.has_sub_menu ? toggleSubMenu(itemIndex) : handleMenuLinkClick(menuItem)"
            :aria-expanded="openSubMenu === itemIndex"
          >
            <h4 class="tw-text-[var(--c-text_primary)] tw-duration-300 group-hover:!tw-text-[var(--c-primary)]">
              {{ menuItem.name }}
            </h4>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <svg
              v-if="menuItem.has_sub_menu === true"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="var(--c-text_primary)"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 8.49799H8V14.498H6V8.49799H0V6.49799H6V0.497986H8V6.49799H14V8.49799Z"
                fill="var(--c-text_primary)"
                class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </a>
          <div
            class="submenu js-submenu"
            :class="{ 'is-active': openSubMenu === itemIndex }"
            role="region"
            :aria-hidden="openSubMenu !== itemIndex"
          >
            <div class="submenu__wrap">
              <div
                class="submenu__item"
                style="height: 45px"
                v-for="(subMenu, sIndex) in menuItem.sub_menus"
                :key="`subMenu-${itemIndex}-${sIndex}`"
              >
                <nuxt-link
                  :to="subMenu.url || '/'"
                  :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
                  :external="true"
                >
                  <h5 class="tw-duration-300 hover:!tw-text-[var(--c-primary)]" style="text-transform: none !important">
                    {{ subMenu.name }}
                  </h5>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
        <div class="!tw-mt-auto tw-flex tw-w-full tw-flex-col tw-gap-5 lg:!tw-hidden">
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-3">
            <nuxt-link v-if="vars.facebookUrl" :external="true" :to="vars.facebookUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M19.6693 19.2501H21.7526L22.5859 15.9167H19.6693V14.2501C19.6693 13.3917 19.6693 12.5834 21.3359 12.5834H22.5859V9.78341C22.3143 9.74758 21.2884 9.66675 20.2051 9.66675C17.9426 9.66675 16.3359 11.0476 16.3359 13.5834V15.9167H13.8359V19.2501H16.3359V26.3334H19.6693V19.2501Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.tiktokUrl" :external="true" :to="vars.tiktokUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M21.8354 12.85C21.2658 12.1997 20.9518 11.3645 20.9521 10.5H18.3771V20.8333C18.3572 21.3925 18.1211 21.9222 17.7186 22.3108C17.316 22.6994 16.7783 22.9166 16.2188 22.9167C15.0354 22.9167 14.0521 21.95 14.0521 20.75C14.0521 19.3167 15.4354 18.2417 16.8604 18.6833V16.05C13.9854 15.6667 11.4688 17.9 11.4688 20.75C11.4688 23.525 13.7688 25.5 16.2104 25.5C18.8271 25.5 20.9521 23.375 20.9521 20.75V15.5083C21.9962 16.2582 23.2499 16.6605 24.5354 16.6583V14.0833C24.5354 14.0833 22.9688 14.1583 21.8354 12.85Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.instagramUrl" :external="true" :to="vars.instagramUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M14.4974 9.66675H21.4974C24.1641 9.66675 26.3307 11.8334 26.3307 14.5001V21.5001C26.3307 22.782 25.8215 24.0113 24.9151 24.9178C24.0087 25.8242 22.7793 26.3334 21.4974 26.3334H14.4974C11.8307 26.3334 9.66406 24.1667 9.66406 21.5001V14.5001C9.66406 13.2182 10.1733 11.9888 11.0797 11.0824C11.9861 10.176 13.2155 9.66675 14.4974 9.66675ZM14.3307 11.3334C13.5351 11.3334 12.772 11.6495 12.2094 12.2121C11.6468 12.7747 11.3307 13.5378 11.3307 14.3334V21.6667C11.3307 23.3251 12.6724 24.6667 14.3307 24.6667H21.6641C22.4597 24.6667 23.2228 24.3507 23.7854 23.7881C24.348 23.2255 24.6641 22.4624 24.6641 21.6667V14.3334C24.6641 12.6751 23.3224 11.3334 21.6641 11.3334H14.3307ZM22.3724 12.5834C22.6487 12.5834 22.9136 12.6932 23.109 12.8885C23.3043 13.0839 23.4141 13.3488 23.4141 13.6251C23.4141 13.9013 23.3043 14.1663 23.109 14.3617C22.9136 14.557 22.6487 14.6667 22.3724 14.6667C22.0961 14.6667 21.8312 14.557 21.6358 14.3617C21.4405 14.1663 21.3307 13.9013 21.3307 13.6251C21.3307 13.3488 21.4405 13.0839 21.6358 12.8885C21.8312 12.6932 22.0961 12.5834 22.3724 12.5834ZM17.9974 13.8334C19.1025 13.8334 20.1623 14.2724 20.9437 15.0538C21.7251 15.8352 22.1641 16.895 22.1641 18.0001C22.1641 19.1052 21.7251 20.165 20.9437 20.9464C20.1623 21.7278 19.1025 22.1667 17.9974 22.1667C16.8923 22.1667 15.8325 21.7278 15.0511 20.9464C14.2697 20.165 13.8307 19.1052 13.8307 18.0001C13.8307 16.895 14.2697 15.8352 15.0511 15.0538C15.8325 14.2724 16.8923 13.8334 17.9974 13.8334ZM17.9974 15.5001C17.3344 15.5001 16.6985 15.7635 16.2296 16.2323C15.7608 16.7012 15.4974 17.337 15.4974 18.0001C15.4974 18.6631 15.7608 19.299 16.2296 19.7678C16.6985 20.2367 17.3344 20.5001 17.9974 20.5001C18.6604 20.5001 19.2963 20.2367 19.7652 19.7678C20.234 19.299 20.4974 18.6631 20.4974 18.0001C20.4974 17.337 20.234 16.7012 19.7652 16.2323C19.2963 15.7635 18.6604 15.5001 17.9974 15.5001Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.youtubeUrl" :external="true" :to="vars.youtubeUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <g clip-path="url(#clip0_32_232)">
                    <path
                      d="M17.9974 11.3333C18.7099 11.3333 19.4407 11.3516 20.1491 11.3816L20.9857 11.4216L21.7866 11.4691L22.5366 11.5199L23.2216 11.5733C23.9649 11.6302 24.6644 11.9474 25.197 12.4691C25.7296 12.9909 26.0611 13.6837 26.1332 14.4258L26.1666 14.7799L26.2291 15.5383C26.2874 16.3241 26.3307 17.1808 26.3307 17.9999C26.3307 18.8191 26.2874 19.6758 26.2291 20.4616L26.1666 21.2199C26.1557 21.3416 26.1449 21.4591 26.1332 21.5741C26.0611 22.3163 25.7294 23.0092 25.1967 23.531C24.6639 24.0527 23.9643 24.3699 23.2207 24.4266L22.5374 24.4791L21.7874 24.5308L20.9857 24.5782L20.1491 24.6182C19.4323 24.6494 18.7149 24.6655 17.9974 24.6666C17.2799 24.6655 16.5625 24.6494 15.8457 24.6182L15.0091 24.5782L14.2082 24.5308L13.4582 24.4791L12.7732 24.4266C12.0299 24.3697 11.3304 24.0525 10.7978 23.5307C10.2652 23.009 9.93371 22.3161 9.86156 21.5741L9.82823 21.2199L9.76573 20.4616C9.70201 19.6425 9.6681 18.8214 9.66406 17.9999C9.66406 17.1808 9.7074 16.3241 9.76573 15.5383L9.82823 14.7799C9.83906 14.6583 9.8499 14.5408 9.86156 14.4258C9.93368 13.6838 10.2651 12.9911 10.7975 12.4694C11.3299 11.9476 12.0292 11.6303 12.7724 11.5733L13.4566 11.5199L14.2066 11.4691L15.0082 11.4216L15.8449 11.3816C16.562 11.3504 17.2796 11.3343 17.9974 11.3333ZM17.9974 12.9999C17.3099 12.9999 16.6024 13.0183 15.9141 13.0466L15.0991 13.0858L14.3166 13.1316L13.5816 13.1816L12.9082 13.2341C12.5543 13.2592 12.2208 13.4088 11.9666 13.6564C11.7125 13.9039 11.5542 14.2335 11.5199 14.5866C11.4224 15.5941 11.3307 16.8483 11.3307 17.9999C11.3307 19.1516 11.4224 20.4058 11.5199 21.4133C11.5907 22.1399 12.1674 22.7049 12.9082 22.7658L13.5816 22.8174L14.3166 22.8674L15.0991 22.9141L15.9141 22.9533C16.6024 22.9816 17.3099 22.9999 17.9974 22.9999C18.6849 22.9999 19.3924 22.9816 20.0807 22.9533L20.8957 22.9141L21.6782 22.8682L22.4132 22.8183L23.0866 22.7658C23.4405 22.7406 23.774 22.591 24.0282 22.3435C24.2823 22.0959 24.4405 21.7664 24.4749 21.4133C24.5724 20.4058 24.6641 19.1516 24.6641 17.9999C24.6641 16.8483 24.5724 15.5941 24.4749 14.5866C24.4405 14.2335 24.2823 13.9039 24.0282 13.6564C23.774 13.4088 23.4405 13.2592 23.0866 13.2341L22.4132 13.1824L21.6782 13.1324L20.8957 13.0858L20.0807 13.0466C19.3867 13.0167 18.6921 13.0012 17.9974 12.9999ZM16.3307 15.9791C16.3307 15.8976 16.3505 15.8174 16.3885 15.7454C16.4265 15.6733 16.4816 15.6117 16.5489 15.5658C16.6161 15.5199 16.6936 15.4911 16.7745 15.4819C16.8555 15.4728 16.9374 15.4835 17.0132 15.5133L17.0807 15.5466L20.5807 17.5666C20.6504 17.6068 20.7094 17.6632 20.7526 17.7311C20.7958 17.799 20.822 17.8763 20.829 17.9565C20.8359 18.0366 20.8234 18.1173 20.7925 18.1916C20.7617 18.2659 20.7133 18.3316 20.6516 18.3833L20.5807 18.4333L17.0807 20.4541C17.0102 20.4949 16.9308 20.5179 16.8493 20.521C16.7679 20.5241 16.6869 20.5073 16.6134 20.472C16.54 20.4367 16.4763 20.3839 16.4279 20.3183C16.3795 20.2528 16.3478 20.1763 16.3357 20.0958L16.3307 20.0208V15.9791Z"
                      fill="var(--c-text_primary)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_32_232">
                      <rect width="20" height="20" fill="var(--c-text_primary)" transform="translate(8 8)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.linkedinUrl" :external="true" :to="vars.linkedinUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M13.7865 12.1668C13.7862 12.6088 13.6104 13.0326 13.2977 13.345C12.985 13.6574 12.561 13.8328 12.119 13.8326C11.6769 13.8324 11.2531 13.6566 10.9407 13.3439C10.6283 13.0311 10.4529 12.6071 10.4531 12.1651C10.4533 11.7231 10.6292 11.2992 10.9419 10.9868C11.2546 10.6744 11.6786 10.499 12.1206 10.4993C12.5627 10.4995 12.9865 10.6753 13.2989 10.988C13.6113 11.3007 13.7867 11.7247 13.7865 12.1668ZM13.8365 15.0668H10.5031V25.5001H13.8365V15.0668ZM19.1031 15.0668H15.7865V25.5001H19.0698V20.0251C19.0698 16.9751 23.0448 16.6918 23.0448 20.0251V25.5001H26.3365V18.8918C26.3365 13.7501 20.4531 13.9418 19.0698 16.4668L19.1031 15.0668Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`button-${index}`"
            :class="`n-${button.button_type} tw-w-full md:!tw-hidden`"
            :to="button.button_link || '/'"
            :external="true"
          >
            {{ button.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>

    <div
      class="menu__close js-menuClose js-menu-button tw-group"
      style="border-color: var(--c-primary) !important; background-color: var(--c-section_primary) !important"
      @click="toggleMenu"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="var(--c-section_primary)"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
          fill="var(--c-text_primary)"
          class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
        />
      </svg>
    </div>
  </div>

  <header
    v-if="variants.v3 === variant"
    :class="[
      'header',
      '-type-1',
      'js-header',
      {
        'scrolled tw-shadow-md': isScrolled,
        'fixed-color': vars.fixedColorBool,
        'is-hidden': isPopupOpen,
      },
    ]"
    :style="headerStyle"
  >
    <div data-anim="fade delay-3" class="header__container tw-items-center">
      <div class="header__left">
        <button class="!tw-text-white" :class="menuButtonClass" :style="menuButtonStyle" @click="toggleMenu">
          <i class="before:!tw-bg-white after:!tw-bg-white"></i>
          <span class="tw-text-white">Menu</span>
        </button>
        <nuxt-link
          :to="homeLink"
          class="header__logo n-link"
          :external="true"
          :class="{ 'tw-block lg:tw-hidden': vars.logoCenterBool }"
        >
          <img
            :src="vars.logoVersionText === 'v3' ? logoV3 : logo"
            alt="logo icon"
            class="logo-image"
            :class="{ '!tw-max-h-[80px]': shouldApplyV3LogoSize }"
          />
        </nuxt-link>
      </div>
      <nuxt-link
        :to="homeLink"
        v-if="company.company_key !== 'copeandco'"
        class="header__logo n-link"
        :external="true"
        :class="{ 'tw-hidden lg:tw-block': vars.logoCenterBool }"
      >
        <img
          :src="vars.logoVersionText === 'v3' ? logoV3 : logo"
          alt="logo icon"
          class="logo-image"
          :class="{ '!tw-max-h-[80px]': shouldApplyV3LogoSize }"
        />
      </nuxt-link>
      <div class="header__right">
        <div v-if="vars.socials" class="header__socials">
          <a
            v-for="(item, i) in (vars.socials as unknown as SocialItem[]) || []"
            :key="`social-${i}`"
            :href="item.url"
            :class="item.iconClass"
            target="_blank"
            rel="noopener noreferrer"
          ></a>
        </div>
        <div v-if="vars.languages" class="header__language lg:d-none">
          <template v-for="(lang, idx) in (vars.languages as unknown as string[]) || []" :key="lang">
            <a href="javascript:void(0)" @click.prevent="changeLanguage(lang)">
              {{ lang.toUpperCase() }}
            </a>
            <span v-if="idx < ((vars.languages as unknown as string[]) || []).length - 1"></span>
          </template>
        </div>
        <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-start tw-gap-3">
          <div class="tw-flex tw-gap-3">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[buttons.length >= 2 ? '' : 'tw-w-auto', menuVisible ? 'n-primary' : `n-${button.button_type}`]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </header>

  <div
    v-if="variants.v3 === variant"
    class="menu -top-header js-menu"
    :class="{ 'is-open': menuVisible }"
    :style="menuStyle"
  >
    <div class="menu__left" style="background-color: var(--c-section_primary)">
      <div class="menuNav js-menuNav tw-mt-14">
        <div
          v-for="(menuItem, itemIndex) in columnOneMenu"
          :key="`menuItem-${itemIndex}`"
          class="menuNav__item"
          :class="menuItem.has_sub_menu ? '-has-submenu js-has-submenu' : ''"
        >
          <a
            href="javascript:void(0)"
            class="tw-group hover:!tw-text-[var(--c-secondary)]"
            style="text-transform: none !important"
            @click="menuItem.has_sub_menu ? toggleSubMenu(itemIndex) : handleMenuLinkClick(menuItem)"
            :aria-expanded="openSubMenu === itemIndex"
          >
            <h4>{{ menuItem.name }}</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <svg
              v-if="menuItem.has_sub_menu === true"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 8.49799H8V14.498H6V8.49799H0V6.49799H6V0.497986H8V6.49799H14V8.49799Z"
                fill="white"
                class="tw-duration-300 group-hover:tw-fill-[var(--c-secondary)]"
              />
            </svg>
          </a>
          <div
            class="submenu js-submenu"
            :class="{ 'is-active': openSubMenu === itemIndex }"
            role="region"
            :aria-hidden="openSubMenu !== itemIndex"
          >
            <div class="submenu__wrap">
              <div
                class="submenu__item"
                v-for="(subMenu, sIndex) in menuItem.sub_menus"
                :key="`subMenu-${itemIndex}-${sIndex}`"
              >
                <nuxt-link
                  :to="subMenu.url || '/'"
                  :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
                  :external="true"
                >
                  <h6>{{ subMenu.name }}</h6>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
        <div class="!tw-mt-20 tw-flex tw-flex-col tw-items-start tw-justify-center">
          <nuxt-link
            v-for="button in buttons"
            :class="`n-${button.button_type} tw-block tw-w-full md:tw-w-auto`"
            :external="true"
            :to="button.button_link"
          >
            {{ button.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>
    <div class="menu__right tw-relative">
      <NuxtImg
        v-if="vars.backgroundImage"
        :src="(vars.backgroundImage as string) || ''"
        class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      />
    </div>

    <div
      class="menu__close js-menuClose js-menu-button"
      style="border-color: var(--c-primary) !important; background-color: var(--c-section_primary)"
      @click="toggleMenu"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
          fill="#fff"
        />
      </svg>
    </div>
  </div>

  <header
    v-if="variants.v4 === variant"
    :class="[
      'header',
      '-type-1',
      'js-header',
      {
        scrolled: isScrolled,
        'fixed-color': vars.fixedColorBool,
        'is-hidden': isPopupOpen,
      },
    ]"
    class="v2 tw-flex tw-flex-col tw-items-center tw-justify-center"
    style=""
    :style="headerStyle"
  >
    <div data-anim="fade delay-3" class="header__container tw-items-center">
      <div class="header__left tw-flex-row-reverse">
        <div class="tw-flex tw-items-center tw-gap-5">
          <nuxt-link :to="homeLink" class="header__logo n-link tw-w-[130px]" :external="true">
            <NuxtImg :src="logoV2" alt="logo icon" class="logo-image !tw-w-full" />
          </nuxt-link>
          <button
            @click="toggleTheme"
            class="focus:outline-none tw-group !tw-rounded-full tw-transition-transform tw-duration-300 hover:tw-scale-95"
            style="border-color: var(--c-text_primary); padding: 12px !important"
          >
            <svg
              v-if="!isLightMode"
              class="tw-transition-transform tw-duration-300 group-hover:tw-rotate-90"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.375 3.125V1.25C9.375 1.08424 9.44085 0.925268 9.55806 0.808058C9.67527 0.690848 9.83424 0.625 10 0.625C10.1658 0.625 10.3247 0.690848 10.4419 0.808058C10.5592 0.925268 10.625 1.08424 10.625 1.25V3.125C10.625 3.29076 10.5592 3.44973 10.4419 3.56694C10.3247 3.68415 10.1658 3.75 10 3.75C9.83424 3.75 9.67527 3.68415 9.55806 3.56694C9.44085 3.44973 9.375 3.29076 9.375 3.125ZM15 10C15 10.9889 14.7068 11.9556 14.1573 12.7779C13.6079 13.6001 12.827 14.241 11.9134 14.6194C10.9998 14.9978 9.99445 15.0969 9.02455 14.9039C8.05464 14.711 7.16373 14.2348 6.46447 13.5355C5.7652 12.8363 5.289 11.9454 5.09607 10.9755C4.90315 10.0055 5.00216 9.00021 5.3806 8.08658C5.75904 7.17295 6.3999 6.39206 7.22215 5.84265C8.04439 5.29324 9.01109 5 10 5C11.3256 5.00145 12.5966 5.5287 13.5339 6.46606C14.4713 7.40343 14.9986 8.67436 15 10ZM13.75 10C13.75 9.25832 13.5301 8.5333 13.118 7.91661C12.706 7.29993 12.1203 6.81928 11.4351 6.53545C10.7498 6.25162 9.99584 6.17736 9.26841 6.32206C8.54098 6.46675 7.8728 6.8239 7.34835 7.34835C6.8239 7.8728 6.46675 8.54098 6.32206 9.26841C6.17736 9.99584 6.25162 10.7498 6.53545 11.4351C6.81928 12.1203 7.29993 12.706 7.91661 13.118C8.5333 13.5301 9.25832 13.75 10 13.75C10.9942 13.749 11.9475 13.3535 12.6505 12.6505C13.3535 11.9475 13.749 10.9942 13.75 10ZM4.55781 5.44219C4.67509 5.55946 4.83415 5.62535 5 5.62535C5.16585 5.62535 5.32491 5.55946 5.44219 5.44219C5.55946 5.32491 5.62535 5.16585 5.62535 5C5.62535 4.83415 5.55946 4.67509 5.44219 4.55781L4.19219 3.30781C4.07491 3.19054 3.91585 3.12465 3.75 3.12465C3.58415 3.12465 3.42509 3.19054 3.30781 3.30781C3.19054 3.42509 3.12465 3.58415 3.12465 3.75C3.12465 3.91585 3.19054 4.07491 3.30781 4.19219L4.55781 5.44219ZM4.55781 14.5578L3.30781 15.8078C3.19054 15.9251 3.12465 16.0841 3.12465 16.25C3.12465 16.4159 3.19054 16.5749 3.30781 16.6922C3.42509 16.8095 3.58415 16.8753 3.75 16.8753C3.91585 16.8753 4.07491 16.8095 4.19219 16.6922L5.44219 15.4422C5.50026 15.3841 5.54632 15.3152 5.57775 15.2393C5.60917 15.1634 5.62535 15.0821 5.62535 15C5.62535 14.9179 5.60917 14.8366 5.57775 14.7607C5.54632 14.6848 5.50026 14.6159 5.44219 14.5578C5.38412 14.4997 5.31518 14.4537 5.23931 14.4223C5.16344 14.3908 5.08212 14.3747 5 14.3747C4.91788 14.3747 4.83656 14.3908 4.76069 14.4223C4.68482 14.4537 4.61588 14.4997 4.55781 14.5578ZM15 5.625C15.0821 5.62506 15.1634 5.60895 15.2393 5.57759C15.3152 5.54622 15.3841 5.50021 15.4422 5.44219L16.6922 4.19219C16.8095 4.07491 16.8753 3.91585 16.8753 3.75C16.8753 3.58415 16.8095 3.42509 16.6922 3.30781C16.5749 3.19054 16.4159 3.12465 16.25 3.12465C16.0841 3.12465 15.9251 3.19054 15.8078 3.30781L14.5578 4.55781C14.4703 4.64522 14.4107 4.75663 14.3865 4.87793C14.3624 4.99924 14.3748 5.12498 14.4221 5.23924C14.4695 5.35351 14.5496 5.45116 14.6525 5.51982C14.7554 5.58849 14.8763 5.6251 15 5.625ZM15.4422 14.5578C15.3249 14.4405 15.1659 14.3747 15 14.3747C14.8341 14.3747 14.6751 14.4405 14.5578 14.5578C14.4405 14.6751 14.3747 14.8341 14.3747 15C14.3747 15.1659 14.4405 15.3249 14.5578 15.4422L15.8078 16.6922C15.8659 16.7503 15.9348 16.7963 16.0107 16.8277C16.0866 16.8592 16.1679 16.8753 16.25 16.8753C16.3321 16.8753 16.4134 16.8592 16.4893 16.8277C16.5652 16.7963 16.6341 16.7503 16.6922 16.6922C16.7503 16.6341 16.7963 16.5652 16.8277 16.4893C16.8592 16.4134 16.8753 16.3321 16.8753 16.25C16.8753 16.1679 16.8592 16.0866 16.8277 16.0107C16.7963 15.9348 16.7503 15.8659 16.6922 15.8078L15.4422 14.5578ZM3.75 10C3.75 9.83424 3.68415 9.67527 3.56694 9.55806C3.44973 9.44085 3.29076 9.375 3.125 9.375H1.25C1.08424 9.375 0.925268 9.44085 0.808058 9.55806C0.690848 9.67527 0.625 9.83424 0.625 10C0.625 10.1658 0.690848 10.3247 0.808058 10.4419C0.925268 10.5592 1.08424 10.625 1.25 10.625H3.125C3.29076 10.625 3.44973 10.5592 3.56694 10.4419C3.68415 10.3247 3.75 10.1658 3.75 10ZM10 16.25C9.83424 16.25 9.67527 16.3158 9.55806 16.4331C9.44085 16.5503 9.375 16.7092 9.375 16.875V18.75C9.375 18.9158 9.44085 19.0747 9.55806 19.1919C9.67527 19.3092 9.83424 19.375 10 19.375C10.1658 19.375 10.3247 19.3092 10.4419 19.1919C10.5592 19.0747 10.625 18.9158 10.625 18.75V16.875C10.625 16.7092 10.5592 16.5503 10.4419 16.4331C10.3247 16.3158 10.1658 16.25 10 16.25ZM18.75 9.375H16.875C16.7092 9.375 16.5503 9.44085 16.4331 9.55806C16.3158 9.67527 16.25 9.83424 16.25 10C16.25 10.1658 16.3158 10.3247 16.4331 10.4419C16.5503 10.5592 16.7092 10.625 16.875 10.625H18.75C18.9158 10.625 19.0747 10.5592 19.1919 10.4419C19.3092 10.3247 19.375 10.1658 19.375 10C19.375 9.83424 19.3092 9.67527 19.1919 9.55806C19.0747 9.44085 18.9158 9.375 18.75 9.375Z"
                fill="var(--c-text_primary)"
              />
            </svg>
            <svg v-else width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M16.1352 10.2218C16.075 10.1617 15.9995 10.1191 15.917 10.0986C15.8344 10.0781 15.7478 10.0805 15.6664 10.1054C14.4477 10.4738 13.1518 10.5046 11.9169 10.1945C10.682 9.88445 9.55439 9.24514 8.65421 8.34471C7.75402 7.44428 7.11501 6.31649 6.80527 5.08152C6.49552 3.84655 6.52666 2.55067 6.89535 1.332C6.91998 1.25073 6.92207 1.1643 6.9014 1.08194C6.88073 0.999575 6.83807 0.924373 6.77799 0.864367C6.7179 0.804361 6.64264 0.761805 6.56025 0.741243C6.47786 0.720682 6.39143 0.722888 6.3102 0.747627C4.69423 1.2434 3.27569 2.23602 2.25629 3.58435C1.10071 5.11879 0.538301 7.01901 0.67258 8.93522C0.80686 10.8514 1.62879 12.6546 2.98708 14.0129C4.34537 15.3712 6.14858 16.1931 8.06479 16.3274C9.98099 16.4617 11.8812 15.8993 13.4157 14.7437C14.764 13.7243 15.7566 12.3058 16.2524 10.6898C16.2771 10.6085 16.2793 10.522 16.2586 10.4396C16.238 10.3572 16.1953 10.2819 16.1352 10.2218ZM12.8539 13.9945C11.4999 15.01 9.82503 15.503 8.13676 15.3831C6.44849 15.2631 4.86015 14.5381 3.66335 13.3413C2.46655 12.1445 1.74162 10.5562 1.62163 8.86794C1.50165 7.17967 1.99468 5.50477 3.0102 4.15075C3.73352 3.19171 4.68829 2.43181 5.7852 1.94216C5.55426 3.21061 5.63437 4.51615 6.01866 5.74685C6.40294 6.97756 7.07994 8.09672 7.99162 9.00839C8.90329 9.92007 10.0225 10.5971 11.2532 10.9814C12.4839 11.3656 13.7894 11.4457 15.0579 11.2148C14.5695 12.3132 13.8104 13.2696 12.8516 13.9945H12.8539Z"
                fill="var(--c-text_primary)"
              />
            </svg>
          </button>
        </div>
        <button
          class="n-link md:!tw-hidden"
          style="color: var(--c-text_primary) !important"
          :class="menuButtonClass"
          :style="menuButtonStyle"
          @click="toggleMenu"
        >
          <i class="custom-color-menu"></i>
        </button>
      </div>
      <div class="header__right">
        <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-start tw-gap-3">
          <div class="tw-hidden tw-items-center tw-justify-center tw-gap-1 lg:tw-flex">
            <nuxt-link v-if="vars.facebookUrl" :external="true" :to="vars.facebookUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M19.6693 19.2501H21.7526L22.5859 15.9167H19.6693V14.2501C19.6693 13.3917 19.6693 12.5834 21.3359 12.5834H22.5859V9.78341C22.3143 9.74758 21.2884 9.66675 20.2051 9.66675C17.9426 9.66675 16.3359 11.0476 16.3359 13.5834V15.9167H13.8359V19.2501H16.3359V26.3334H19.6693V19.2501Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.tiktokUrl" :external="true" :to="vars.tiktokUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M21.8354 12.85C21.2658 12.1997 20.9518 11.3645 20.9521 10.5H18.3771V20.8333C18.3572 21.3925 18.1211 21.9222 17.7186 22.3108C17.316 22.6994 16.7783 22.9166 16.2188 22.9167C15.0354 22.9167 14.0521 21.95 14.0521 20.75C14.0521 19.3167 15.4354 18.2417 16.8604 18.6833V16.05C13.9854 15.6667 11.4688 17.9 11.4688 20.75C11.4688 23.525 13.7688 25.5 16.2104 25.5C18.8271 25.5 20.9521 23.375 20.9521 20.75V15.5083C21.9962 16.2582 23.2499 16.6605 24.5354 16.6583V14.0833C24.5354 14.0833 22.9688 14.1583 21.8354 12.85Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.instagramUrl" :external="true" :to="vars.instagramUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M14.4974 9.66675H21.4974C24.1641 9.66675 26.3307 11.8334 26.3307 14.5001V21.5001C26.3307 22.782 25.8215 24.0113 24.9151 24.9178C24.0087 25.8242 22.7793 26.3334 21.4974 26.3334H14.4974C11.8307 26.3334 9.66406 24.1667 9.66406 21.5001V14.5001C9.66406 13.2182 10.1733 11.9888 11.0797 11.0824C11.9861 10.176 13.2155 9.66675 14.4974 9.66675ZM14.3307 11.3334C13.5351 11.3334 12.772 11.6495 12.2094 12.2121C11.6468 12.7747 11.3307 13.5378 11.3307 14.3334V21.6667C11.3307 23.3251 12.6724 24.6667 14.3307 24.6667H21.6641C22.4597 24.6667 23.2228 24.3507 23.7854 23.7881C24.348 23.2255 24.6641 22.4624 24.6641 21.6667V14.3334C24.6641 12.6751 23.3224 11.3334 21.6641 11.3334H14.3307ZM22.3724 12.5834C22.6487 12.5834 22.9136 12.6932 23.109 12.8885C23.3043 13.0839 23.4141 13.3488 23.4141 13.6251C23.4141 13.9013 23.3043 14.1663 23.109 14.3617C22.9136 14.557 22.6487 14.6667 22.3724 14.6667C22.0961 14.6667 21.8312 14.557 21.6358 14.3617C21.4405 14.1663 21.3307 13.9013 21.3307 13.6251C21.3307 13.3488 21.4405 13.0839 21.6358 12.8885C21.8312 12.6932 22.0961 12.5834 22.3724 12.5834ZM17.9974 13.8334C19.1025 13.8334 20.1623 14.2724 20.9437 15.0538C21.7251 15.8352 22.1641 16.895 22.1641 18.0001C22.1641 19.1052 21.7251 20.165 20.9437 20.9464C20.1623 21.7278 19.1025 22.1667 17.9974 22.1667C16.8923 22.1667 15.8325 21.7278 15.0511 20.9464C14.2697 20.165 13.8307 19.1052 13.8307 18.0001C13.8307 16.895 14.2697 15.8352 15.0511 15.0538C15.8325 14.2724 16.8923 13.8334 17.9974 13.8334ZM17.9974 15.5001C17.3344 15.5001 16.6985 15.7635 16.2296 16.2323C15.7608 16.7012 15.4974 17.337 15.4974 18.0001C15.4974 18.6631 15.7608 19.299 16.2296 19.7678C16.6985 20.2367 17.3344 20.5001 17.9974 20.5001C18.6604 20.5001 19.2963 20.2367 19.7652 19.7678C20.234 19.299 20.4974 18.6631 20.4974 18.0001C20.4974 17.337 20.234 16.7012 19.7652 16.2323C19.2963 15.7635 18.6604 15.5001 17.9974 15.5001Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.youtubeUrl" :external="true" :to="vars.youtubeUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <g clip-path="url(#clip0_32_232)">
                    <path
                      d="M17.9974 11.3333C18.7099 11.3333 19.4407 11.3516 20.1491 11.3816L20.9857 11.4216L21.7866 11.4691L22.5366 11.5199L23.2216 11.5733C23.9649 11.6302 24.6644 11.9474 25.197 12.4691C25.7296 12.9909 26.0611 13.6837 26.1332 14.4258L26.1666 14.7799L26.2291 15.5383C26.2874 16.3241 26.3307 17.1808 26.3307 17.9999C26.3307 18.8191 26.2874 19.6758 26.2291 20.4616L26.1666 21.2199C26.1557 21.3416 26.1449 21.4591 26.1332 21.5741C26.0611 22.3163 25.7294 23.0092 25.1967 23.531C24.6639 24.0527 23.9643 24.3699 23.2207 24.4266L22.5374 24.4791L21.7874 24.5308L20.9857 24.5782L20.1491 24.6182C19.4323 24.6494 18.7149 24.6655 17.9974 24.6666C17.2799 24.6655 16.5625 24.6494 15.8457 24.6182L15.0091 24.5782L14.2082 24.5308L13.4582 24.4791L12.7732 24.4266C12.0299 24.3697 11.3304 24.0525 10.7978 23.5307C10.2652 23.009 9.93371 22.3161 9.86156 21.5741L9.82823 21.2199L9.76573 20.4616C9.70201 19.6425 9.6681 18.8214 9.66406 17.9999C9.66406 17.1808 9.7074 16.3241 9.76573 15.5383L9.82823 14.7799C9.83906 14.6583 9.8499 14.5408 9.86156 14.4258C9.93368 13.6838 10.2651 12.9911 10.7975 12.4694C11.3299 11.9476 12.0292 11.6303 12.7724 11.5733L13.4566 11.5199L14.2066 11.4691L15.0082 11.4216L15.8449 11.3816C16.562 11.3504 17.2796 11.3343 17.9974 11.3333ZM17.9974 12.9999C17.3099 12.9999 16.6024 13.0183 15.9141 13.0466L15.0991 13.0858L14.3166 13.1316L13.5816 13.1816L12.9082 13.2341C12.5543 13.2592 12.2208 13.4088 11.9666 13.6564C11.7125 13.9039 11.5542 14.2335 11.5199 14.5866C11.4224 15.5941 11.3307 16.8483 11.3307 17.9999C11.3307 19.1516 11.4224 20.4058 11.5199 21.4133C11.5907 22.1399 12.1674 22.7049 12.9082 22.7658L13.5816 22.8174L14.3166 22.8674L15.0991 22.9141L15.9141 22.9533C16.6024 22.9816 17.3099 22.9999 17.9974 22.9999C18.6849 22.9999 19.3924 22.9816 20.0807 22.9533L20.8957 22.9141L21.6782 22.8682L22.4132 22.8183L23.0866 22.7658C23.4405 22.7406 23.774 22.591 24.0282 22.3435C24.2823 22.0959 24.4405 21.7664 24.4749 21.4133C24.5724 20.4058 24.6641 19.1516 24.6641 17.9999C24.6641 16.8483 24.5724 15.5941 24.4749 14.5866C24.4405 14.2335 24.2823 13.9039 24.0282 13.6564C23.774 13.4088 23.4405 13.2592 23.0866 13.2341L22.4132 13.1824L21.6782 13.1324L20.8957 13.0858L20.0807 13.0466C19.3867 13.0167 18.6921 13.0012 17.9974 12.9999ZM16.3307 15.9791C16.3307 15.8976 16.3505 15.8174 16.3885 15.7454C16.4265 15.6733 16.4816 15.6117 16.5489 15.5658C16.6161 15.5199 16.6936 15.4911 16.7745 15.4819C16.8555 15.4728 16.9374 15.4835 17.0132 15.5133L17.0807 15.5466L20.5807 17.5666C20.6504 17.6068 20.7094 17.6632 20.7526 17.7311C20.7958 17.799 20.822 17.8763 20.829 17.9565C20.8359 18.0366 20.8234 18.1173 20.7925 18.1916C20.7617 18.2659 20.7133 18.3316 20.6516 18.3833L20.5807 18.4333L17.0807 20.4541C17.0102 20.4949 16.9308 20.5179 16.8493 20.521C16.7679 20.5241 16.6869 20.5073 16.6134 20.472C16.54 20.4367 16.4763 20.3839 16.4279 20.3183C16.3795 20.2528 16.3478 20.1763 16.3357 20.0958L16.3307 20.0208V15.9791Z"
                      fill="var(--c-text_primary)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_32_232">
                      <rect width="20" height="20" fill="var(--c-text_primary)" transform="translate(8 8)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.linkedinUrl" :external="true" :to="vars.linkedinUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M13.7865 12.1668C13.7862 12.6088 13.6104 13.0326 13.2977 13.345C12.985 13.6574 12.561 13.8328 12.119 13.8326C11.6769 13.8324 11.2531 13.6566 10.9407 13.3439C10.6283 13.0311 10.4529 12.6071 10.4531 12.1651C10.4533 11.7231 10.6292 11.2992 10.9419 10.9868C11.2546 10.6744 11.6786 10.499 12.1206 10.4993C12.5627 10.4995 12.9865 10.6753 13.2989 10.988C13.6113 11.3007 13.7867 11.7247 13.7865 12.1668ZM13.8365 15.0668H10.5031V25.5001H13.8365V15.0668ZM19.1031 15.0668H15.7865V25.5001H19.0698V20.0251C19.0698 16.9751 23.0448 16.6918 23.0448 20.0251V25.5001H26.3365V18.8918C26.3365 13.7501 20.4531 13.9418 19.0698 16.4668L19.1031 15.0668Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
          <div class="tw-flex tw-gap-3">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="`button-${index}`"
              :class="[
                buttons.length >= 2 ? '' : 'tw-w-auto',
                menuVisible ? 'n-primary' : `n-${button.button_type}`,
                'tw-uppercase',
              ]"
              :to="button.button_link || '/'"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>

          <button :class="menuButtonClass" :style="menuButtonStyle" @click="toggleMenu">
            <i class="custom-color-menu"></i>
          </button>
        </div>
      </div>
    </div>
  </header>

  <div
    v-if="variants.v4 === variant"
    class="menu -top-header js-menu"
    :class="{ 'is-open': menuVisible }"
    :style="menuStyle"
  >
    <div class="menu__right tw-relative">
      <NuxtImg
        v-if="vars.backgroundImage"
        :src="(vars.backgroundImage as string) || ''"
        class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover"
      />
    </div>
    <div class="menu__left" style="background-color: var(--c-section_primary)">
      <div class="menuNav js-menuNav tw-flex tw-flex-col md:!tw-ml-20">
        <div
          v-for="(menuItem, itemIndex) in columnOneMenu"
          :key="`menuItem-${itemIndex}`"
          class="menuNav__item"
          :class="menuItem.has_sub_menu ? '-has-submenu js-has-submenu' : ''"
        >
          <a
            href="javascript:void(0)"
            class="tw-group !tw-normal-case hover:!tw-text-[var(--c-primary)]"
            @click="menuItem.has_sub_menu ? toggleSubMenu(itemIndex) : handleMenuLinkClick(menuItem)"
            :aria-expanded="openSubMenu === itemIndex"
          >
            <h4 class="tw-text-[var(--c-text_primary)] tw-duration-300 group-hover:!tw-text-[var(--c-primary)]">
              {{ menuItem.name }}
            </h4>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <svg
              v-if="menuItem.has_sub_menu === true"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="var(--c-text_primary)"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 8.49799H8V14.498H6V8.49799H0V6.49799H6V0.497986H8V6.49799H14V8.49799Z"
                fill="var(--c-text_primary)"
                class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
              />
            </svg>
          </a>
          <div
            class="submenu js-submenu"
            :class="{ 'is-active': openSubMenu === itemIndex }"
            role="region"
            :aria-hidden="openSubMenu !== itemIndex"
          >
            <div class="submenu__wrap">
              <div
                class="submenu__item"
                style="height: 45px"
                v-for="(subMenu, sIndex) in menuItem.sub_menus"
                :key="`subMenu-${itemIndex}-${sIndex}`"
              >
                <nuxt-link
                  :to="subMenu.url || '/'"
                  :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
                  :external="true"
                >
                  <h5 class="tw-duration-300 hover:!tw-text-[var(--c-primary)]" style="text-transform: none !important">
                    {{ subMenu.name }}
                  </h5>
                </nuxt-link>
              </div>
            </div>
          </div>
        </div>
        <div class="!tw-mt-auto tw-flex tw-w-full tw-flex-col tw-gap-5 lg:!tw-hidden">
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-3">
            <nuxt-link v-if="vars.facebookUrl" :external="true" :to="vars.facebookUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M19.6693 19.2501H21.7526L22.5859 15.9167H19.6693V14.2501C19.6693 13.3917 19.6693 12.5834 21.3359 12.5834H22.5859V9.78341C22.3143 9.74758 21.2884 9.66675 20.2051 9.66675C17.9426 9.66675 16.3359 11.0476 16.3359 13.5834V15.9167H13.8359V19.2501H16.3359V26.3334H19.6693V19.2501Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.tiktokUrl" :external="true" :to="vars.tiktokUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M21.8354 12.85C21.2658 12.1997 20.9518 11.3645 20.9521 10.5H18.3771V20.8333C18.3572 21.3925 18.1211 21.9222 17.7186 22.3108C17.316 22.6994 16.7783 22.9166 16.2188 22.9167C15.0354 22.9167 14.0521 21.95 14.0521 20.75C14.0521 19.3167 15.4354 18.2417 16.8604 18.6833V16.05C13.9854 15.6667 11.4688 17.9 11.4688 20.75C11.4688 23.525 13.7688 25.5 16.2104 25.5C18.8271 25.5 20.9521 23.375 20.9521 20.75V15.5083C21.9962 16.2582 23.2499 16.6605 24.5354 16.6583V14.0833C24.5354 14.0833 22.9688 14.1583 21.8354 12.85Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.instagramUrl" :external="true" :to="vars.instagramUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M14.4974 9.66675H21.4974C24.1641 9.66675 26.3307 11.8334 26.3307 14.5001V21.5001C26.3307 22.782 25.8215 24.0113 24.9151 24.9178C24.0087 25.8242 22.7793 26.3334 21.4974 26.3334H14.4974C11.8307 26.3334 9.66406 24.1667 9.66406 21.5001V14.5001C9.66406 13.2182 10.1733 11.9888 11.0797 11.0824C11.9861 10.176 13.2155 9.66675 14.4974 9.66675ZM14.3307 11.3334C13.5351 11.3334 12.772 11.6495 12.2094 12.2121C11.6468 12.7747 11.3307 13.5378 11.3307 14.3334V21.6667C11.3307 23.3251 12.6724 24.6667 14.3307 24.6667H21.6641C22.4597 24.6667 23.2228 24.3507 23.7854 23.7881C24.348 23.2255 24.6641 22.4624 24.6641 21.6667V14.3334C24.6641 12.6751 23.3224 11.3334 21.6641 11.3334H14.3307ZM22.3724 12.5834C22.6487 12.5834 22.9136 12.6932 23.109 12.8885C23.3043 13.0839 23.4141 13.3488 23.4141 13.6251C23.4141 13.9013 23.3043 14.1663 23.109 14.3617C22.9136 14.557 22.6487 14.6667 22.3724 14.6667C22.0961 14.6667 21.8312 14.557 21.6358 14.3617C21.4405 14.1663 21.3307 13.9013 21.3307 13.6251C21.3307 13.3488 21.4405 13.0839 21.6358 12.8885C21.8312 12.6932 22.0961 12.5834 22.3724 12.5834ZM17.9974 13.8334C19.1025 13.8334 20.1623 14.2724 20.9437 15.0538C21.7251 15.8352 22.1641 16.895 22.1641 18.0001C22.1641 19.1052 21.7251 20.165 20.9437 20.9464C20.1623 21.7278 19.1025 22.1667 17.9974 22.1667C16.8923 22.1667 15.8325 21.7278 15.0511 20.9464C14.2697 20.165 13.8307 19.1052 13.8307 18.0001C13.8307 16.895 14.2697 15.8352 15.0511 15.0538C15.8325 14.2724 16.8923 13.8334 17.9974 13.8334ZM17.9974 15.5001C17.3344 15.5001 16.6985 15.7635 16.2296 16.2323C15.7608 16.7012 15.4974 17.337 15.4974 18.0001C15.4974 18.6631 15.7608 19.299 16.2296 19.7678C16.6985 20.2367 17.3344 20.5001 17.9974 20.5001C18.6604 20.5001 19.2963 20.2367 19.7652 19.7678C20.234 19.299 20.4974 18.6631 20.4974 18.0001C20.4974 17.337 20.234 16.7012 19.7652 16.2323C19.2963 15.7635 18.6604 15.5001 17.9974 15.5001Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.youtubeUrl" :external="true" :to="vars.youtubeUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <g clip-path="url(#clip0_32_232)">
                    <path
                      d="M17.9974 11.3333C18.7099 11.3333 19.4407 11.3516 20.1491 11.3816L20.9857 11.4216L21.7866 11.4691L22.5366 11.5199L23.2216 11.5733C23.9649 11.6302 24.6644 11.9474 25.197 12.4691C25.7296 12.9909 26.0611 13.6837 26.1332 14.4258L26.1666 14.7799L26.2291 15.5383C26.2874 16.3241 26.3307 17.1808 26.3307 17.9999C26.3307 18.8191 26.2874 19.6758 26.2291 20.4616L26.1666 21.2199C26.1557 21.3416 26.1449 21.4591 26.1332 21.5741C26.0611 22.3163 25.7294 23.0092 25.1967 23.531C24.6639 24.0527 23.9643 24.3699 23.2207 24.4266L22.5374 24.4791L21.7874 24.5308L20.9857 24.5782L20.1491 24.6182C19.4323 24.6494 18.7149 24.6655 17.9974 24.6666C17.2799 24.6655 16.5625 24.6494 15.8457 24.6182L15.0091 24.5782L14.2082 24.5308L13.4582 24.4791L12.7732 24.4266C12.0299 24.3697 11.3304 24.0525 10.7978 23.5307C10.2652 23.009 9.93371 22.3161 9.86156 21.5741L9.82823 21.2199L9.76573 20.4616C9.70201 19.6425 9.6681 18.8214 9.66406 17.9999C9.66406 17.1808 9.7074 16.3241 9.76573 15.5383L9.82823 14.7799C9.83906 14.6583 9.8499 14.5408 9.86156 14.4258C9.93368 13.6838 10.2651 12.9911 10.7975 12.4694C11.3299 11.9476 12.0292 11.6303 12.7724 11.5733L13.4566 11.5199L14.2066 11.4691L15.0082 11.4216L15.8449 11.3816C16.562 11.3504 17.2796 11.3343 17.9974 11.3333ZM17.9974 12.9999C17.3099 12.9999 16.6024 13.0183 15.9141 13.0466L15.0991 13.0858L14.3166 13.1316L13.5816 13.1816L12.9082 13.2341C12.5543 13.2592 12.2208 13.4088 11.9666 13.6564C11.7125 13.9039 11.5542 14.2335 11.5199 14.5866C11.4224 15.5941 11.3307 16.8483 11.3307 17.9999C11.3307 19.1516 11.4224 20.4058 11.5199 21.4133C11.5907 22.1399 12.1674 22.7049 12.9082 22.7658L13.5816 22.8174L14.3166 22.8674L15.0991 22.9141L15.9141 22.9533C16.6024 22.9816 17.3099 22.9999 17.9974 22.9999C18.6849 22.9999 19.3924 22.9816 20.0807 22.9533L20.8957 22.9141L21.6782 22.8682L22.4132 22.8183L23.0866 22.7658C23.4405 22.7406 23.774 22.591 24.0282 22.3435C24.2823 22.0959 24.4405 21.7664 24.4749 21.4133C24.5724 20.4058 24.6641 19.1516 24.6641 17.9999C24.6641 16.8483 24.5724 15.5941 24.4749 14.5866C24.4405 14.2335 24.2823 13.9039 24.0282 13.6564C23.774 13.4088 23.4405 13.2592 23.0866 13.2341L22.4132 13.1824L21.6782 13.1324L20.8957 13.0858L20.0807 13.0466C19.3867 13.0167 18.6921 13.0012 17.9974 12.9999ZM16.3307 15.9791C16.3307 15.8976 16.3505 15.8174 16.3885 15.7454C16.4265 15.6733 16.4816 15.6117 16.5489 15.5658C16.6161 15.5199 16.6936 15.4911 16.7745 15.4819C16.8555 15.4728 16.9374 15.4835 17.0132 15.5133L17.0807 15.5466L20.5807 17.5666C20.6504 17.6068 20.7094 17.6632 20.7526 17.7311C20.7958 17.799 20.822 17.8763 20.829 17.9565C20.8359 18.0366 20.8234 18.1173 20.7925 18.1916C20.7617 18.2659 20.7133 18.3316 20.6516 18.3833L20.5807 18.4333L17.0807 20.4541C17.0102 20.4949 16.9308 20.5179 16.8493 20.521C16.7679 20.5241 16.6869 20.5073 16.6134 20.472C16.54 20.4367 16.4763 20.3839 16.4279 20.3183C16.3795 20.2528 16.3478 20.1763 16.3357 20.0958L16.3307 20.0208V15.9791Z"
                      fill="var(--c-text_primary)"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_32_232">
                      <rect width="20" height="20" fill="var(--c-text_primary)" transform="translate(8 8)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </nuxt-link>

            <nuxt-link v-if="vars.linkedinUrl" :external="true" :to="vars.linkedinUrl" target="_blank" class="n-link">
              <span>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="18" cy="18" r="18" />
                  <path
                    d="M13.7865 12.1668C13.7862 12.6088 13.6104 13.0326 13.2977 13.345C12.985 13.6574 12.561 13.8328 12.119 13.8326C11.6769 13.8324 11.2531 13.6566 10.9407 13.3439C10.6283 13.0311 10.4529 12.6071 10.4531 12.1651C10.4533 11.7231 10.6292 11.2992 10.9419 10.9868C11.2546 10.6744 11.6786 10.499 12.1206 10.4993C12.5627 10.4995 12.9865 10.6753 13.2989 10.988C13.6113 11.3007 13.7867 11.7247 13.7865 12.1668ZM13.8365 15.0668H10.5031V25.5001H13.8365V15.0668ZM19.1031 15.0668H15.7865V25.5001H19.0698V20.0251C19.0698 16.9751 23.0448 16.6918 23.0448 20.0251V25.5001H26.3365V18.8918C26.3365 13.7501 20.4531 13.9418 19.0698 16.4668L19.1031 15.0668Z"
                    fill="var(--c-text_primary)"
                  />
                </svg>
              </span>
            </nuxt-link>
          </div>
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`button-${index}`"
            :class="`n-${button.button_type} tw-w-full md:!tw-hidden`"
            :to="button.button_link || '/'"
            :external="true"
          >
            {{ button.button_label }}
          </nuxt-link>
        </div>
      </div>
    </div>

    <div
      class="menu__close js-menuClose js-menu-button tw-group"
      style="border-color: var(--c-primary) !important; background-color: var(--c-section_primary) !important"
      @click="toggleMenu"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="var(--c-section_primary)"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
          fill="var(--c-text_primary)"
          class="tw-duration-300 group-hover:tw-fill-[var(--c-primary)]"
        />
      </svg>
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { MenuTypes } from '~/constants/ui.constants';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';
import { useCoreStore } from '~/units/core/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

interface SocialItem {
  url: string;
  iconClass: string;
}

interface ButtonItem {
  button_label: string;
  button_type: string;
  button_link: string;
}

const getCssColorVar = (colorKeyOrValue: string | undefined | null): string => {
  if (!colorKeyOrValue) return '';
  if (colorKeyOrValue.startsWith('#') || colorKeyOrValue.startsWith('rgb') || colorKeyOrValue.startsWith('hsl'))
    return colorKeyOrValue;
  const cleanedKey = colorKeyOrValue.replace(/-/g, '').toLowerCase();
  return `var(--c-${cleanedKey}) !important`;
};

export default defineNuxtComponent({
  name: 'Theme7BaseHeaderOne',
  mixins: [ComponentMixin],
  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
      isPopupOpen: false,
      variants: { v1: 'v1', v2: 'v2', v3: 'v3', v4: 'v4' },
      scrollThreshold: 50,
      popupObserver: null as MutationObserver | null,
      isLightMode: false,
    };
  },
  computed: {
    ...mapState(useWebsiteStore, []),
    ...mapState(useCoreStore, ['isAnythingOnTopVisible']),
    buttons(): any[] {
      return this.groupedVariables.buttons || [];
    },
    columnOneMenu(): any[] {
      const content = this.component?.variables['column_one_content-text'];
      if (content === MenuTypes.HEADER_MENU) {
        const websiteStore = useWebsiteStore();
        const menus = websiteStore.menus || [];
        // Extract header menu items
        const headerMenu = menus.find((menu: any) => menu.type === 'header');
        return headerMenu?.items || [];
      }
      return [];
    },
    headerMenuItems(): MenuItem[] {
      // Get menu items from store or return empty array
      const websiteStore = useWebsiteStore();
      return websiteStore.menus || [];
    },
    homeLink(): string {
      return '/';
    },
    logo(): string {
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;
      const defaultLogo = currentCompany?.logo || '';
      return this.menuVisible ? currentCompany?.light_logo || defaultLogo : defaultLogo;
    },

    logoV1(): string {
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;
      const defaultLogo = currentCompany?.logo || '';
      return defaultLogo;
    },

    logoV3() {
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;
      const defaultLogo = currentCompany?.logo || '';
      const lightLogo = currentCompany?.light_logo || '';

      return this.isScrolled || this.vars.fixedColorBool || this.menuVisible ? lightLogo : defaultLogo;
    },

    logoV2() {
      if (!this.isLightMode) {
        return this.company.logo;
      } else if (this.isLightMode) {
        return this.company.light_logo;
      }
      return this.company.light_logo;
    },

    shouldApplyV3LogoSize(): boolean {
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;
      return this.vars.logoVersionText === 'v3' && this.isScrolled && !!currentCompany?.light_logo;
    },

    menuButtonStyle(): Record<string, string> {
      const styles: Record<string, string> = {};
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;

      // Check if company_key is "kineticestateagents" and not scrolled
      if (currentCompany?.company_key === 'kineticestateagents' && !this.isScrolled) {
        styles.color = '#000000';
      }

      // Check if logoVersionText is 'v3' and scrolled
      if (this.vars.logoVersionText === 'v3' && this.isScrolled) {
        styles.color = 'var(--c-text_primary)';
      }

      // Check if logoVersionText is 'v3' and fixedColorBool is true
      if (this.vars.logoVersionText === 'v3' && Boolean(this.vars.fixedColorBool)) {
        styles.color = 'var(--c-text_primary)';
      }

      return styles;
    },
    menuButtonClass(): string {
      const websiteStore = useWebsiteStore();
      const currentCompany = websiteStore.company as any;

      // Add special class for kinetic estate agents when not scrolled
      if (currentCompany?.company_key === 'kineticestateagents' && !this.isScrolled) {
        return 'header__menuBtn js-menu-button kinetic-dark';
      }

      // Add special class for v3 logo version when scrolled
      if (this.vars.logoVersionText === 'v3' && this.isScrolled) {
        return 'header__menuBtn js-menu-button v3-scrolled';
      }

      // Add special class for v3 logo version when fixedColorBool is true
      if (this.vars.logoVersionText === 'v3' && Boolean(this.vars.fixedColorBool)) {
        return 'header__menuBtn js-menu-button v3-fixed-color';
      }

      return 'header__menuBtn js-menu-button';
    },
    headerStyle(): Record<string, string> {
      const styles: Record<string, string> = {};
      const useFixed = this.isScrolled || this.vars.fixedColorBool;
      styles.backgroundColor = useFixed ? getCssColorVar(this.vars?.backgroundColor as string) : 'transparent';
      const textColor = getCssColorVar(this.vars?.textColor as string);
      if (textColor) styles.color = textColor;
      styles.transition = 'background-color 0.3s ease, color 0.3s ease';
      if (this.menuVisible) {
        styles.backgroundColor = getCssColorVar(this.vars?.backgroundColor as string);
      }
      return styles;
    },
    menuStyle(): Record<string, string> {
      const styles: Record<string, string> = {};
      if (this.menuVisible) {
        styles.backgroundColor = '#ffffff';
      } else {
        const bgColor = getCssColorVar(this.vars?.backgroundColor as string);
        if (bgColor) styles.backgroundColor = bgColor;
      }
      const textColor = getCssColorVar(this.vars?.textColor as string);
      if (textColor) styles.color = textColor;
      return styles;
    },
  },
  methods: {
    toggleTheme() {
      this.isLightMode = !this.isLightMode;
      const htmlElement = document.documentElement;
      htmlElement.classList.toggle('light-mode');

      // Optionally, save the theme preference in localStorage
      if (htmlElement.classList.contains('light-mode')) {
        localStorage.setItem('theme', 'light');
      } else {
        localStorage.setItem('theme', 'dark');
      }
    },

    toggleMenu(): void {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.classList.add('no-scroll');
        this.openSubMenu = null;
      } else {
        document.body.classList.remove('no-scroll');
      }
    },

    toggleSubMenu(index: number): void {
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: menuItem.is_open_new_tab || false,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
    },

    changeLanguage(lang: string): void {},

    handleScroll(): void {
      this.isScrolled = window.scrollY > this.scrollThreshold;
    },

    checkPopupOpen(): void {
      this.isPopupOpen = document.body.classList.contains('popup-open');
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    this.checkPopupOpen();
    const observer = new MutationObserver(() => this.checkPopupOpen());
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.$data.popupObserver = observer;

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light') {
      this.isLightMode = true;
      document.documentElement.classList.add('light-mode');
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove('no-scroll');
    this.$data.popupObserver?.disconnect();
  },
});
</script>

<style scoped>
.header__left.tw-flex-row-reverse > button > i.custom-color-menu::before,
.header__left.tw-flex-row-reverse > button > i.custom-color-menu::after,
.header.-type-1.-dark .header__menuBtn i.custom-color-menu::before,
.header.-type-1.-dark .header__menuBtn i.custom-color-menu::after,
.header.-type-1 .header__menuBtn i.custom-color-menu::before,
.header.-type-1 .header__menuBtn i.custom-color-menu::after {
  background-color: var(--c-text_primary) !important;
}

.light-mode .v2.scrolled {
  background-color: var(--c-section_primary) !important;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.v2.scrolled {
  background-color: var(--c-section_primary) !important;
  box-shadow: 0 5px 20px rgba(255, 255, 255, 0.1);
}

header.-type-1 {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1050;
}
.header.-type-1.fixed-color {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}
.header__logo img.logo-image {
  max-height: 60px;
  width: auto;
  display: block;
  position: relative;
  z-index: 1050;
  transition: opacity 0.3s ease;
  opacity: 1 !important;
}
.header.-type-1 .header__logo {
  position: relative;
  margin-left: 0 !important;
  z-index: 0;
}
.header.__hidden {
  display: none !important;
}
.header.-type-1 .header__container {
  position: relative;
  z-index: 1060;
}
.menuNav__item a {
  padding: 0 !important;
}
.submenu__wrap {
  margin: 0;
  padding: 0;
}
.submenu__item {
  margin: 0;
  padding: 0;
}
.submenu__item h6 {
  color: #666666;
  margin: 0;
  padding: 0;
  line-height: 0;
  transition: color 0.3s ease;
}
.submenu__item h6:hover {
  color: var(--c-secondary) !important;
}

.submenu {
  display: none;
}
.submenu.is-active {
  display: block !important;
}
.menu.is-open {
  z-index: 1040;
}
.header.-type-1 .header__left {
  position: relative;
  z-index: 1060;
}
.header.-type-1.js-header .header__left .header__logo img.logo-image,
.menu.is-open + .header.-type-1 .header__logo img.logo-image {
  opacity: 1 !important;
}
.header.is-hidden {
  display: none !important;
}

/* Kinetic Estate Agents specific styling */
.header__menuBtn.kinetic-dark {
  color: #fff !important;
}

.header__menuBtn.kinetic-dark i::before,
.header__menuBtn.kinetic-dark i::after {
  background-color: #fff !important;
}

.header__menuBtn.kinetic-dark span {
  color: #fff !important;
}

/* V3 Logo Version specific styling when scrolled */
.header__menuBtn.v3-scrolled {
  color: var(--c-text_primary) !important;
}

.header__menuBtn.v3-scrolled i::before,
.header__menuBtn.v3-scrolled i::after {
  background-color: var(--c-text_primary) !important;
}

.header__menuBtn.v3-scrolled span {
  color: var(--c-text_primary) !important;
}

/* V3 Logo Version specific styling when fixed color is enabled */
.header__menuBtn.v3-fixed-color {
  color: var(--c-text_primary) !important;
}

.header__menuBtn.v3-fixed-color i::before,
.header__menuBtn.v3-fixed-color i::after {
  background-color: var(--c-text_primary) !important;
}

.header__menuBtn.v3-fixed-color span {
  color: var(--c-text_primary) !important;
}
</style>
